import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useFocusRing } from "@react-aria/focus";
import styled, { css } from "styled-components";
import { token } from "./token.js";
import { Checkbox } from "./Checkbox.js";
import { Cell } from "./Cell.js";
import { Divider } from "./Divider4.js";
import { StopPropagation } from "./StopPropagation.js";
function Row({
  onClick,
  children,
  onSelect,
  isSelected = false,
  isDisabled = false,
  isPressed = false,
  rightIcon,
  ...props
}) {
  const {
    isFocusVisible,
    focusProps
  } = useFocusRing();
  const isClickable = typeof onClick === "function";
  const isOnClickEnabled = isClickable && !isDisabled;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Divider, {}), /* @__PURE__ */ jsxs(StyledRow, {
      $isPressed: isPressed,
      $isActive: isClickable,
      tabIndex: isOnClickEnabled ? 0 : void 0,
      onClick: isOnClickEnabled ? onClick : void 0,
      onKeyDown: (event) => {
        if (isOnClickEnabled && (event.key === "Enter" || event.key === " ")) {
          event.preventDefault();
          onClick();
        }
      },
      $isDisabled: isDisabled,
      $isFocusVisible: isFocusVisible,
      ...focusProps,
      ...props,
      children: [onSelect && /* @__PURE__ */ jsx(Cell, {
        "data-checkbox-cell": true,
        children: /* @__PURE__ */ jsx(StopPropagation, {
          children: /* @__PURE__ */ jsx(Checkbox, {
            isChecked: isSelected,
            isDisabled,
            onChange: () => {
              onSelect();
            }
          })
        })
      }), children, Boolean(rightIcon) && /* @__PURE__ */ jsx(Cell, {
        "data-icon-cell": true,
        children: /* @__PURE__ */ jsx(Icon, {
          children: rightIcon
        })
      })]
    })]
  });
}
const StyledRow = styled.tr.withConfig({
  displayName: "StyledRow",
  componentId: "sc-noi3s7-0"
})(["", " ", " ", ""], (props) => props.$isActive && css(["--table-row-right-icon-color:", ";border-radius:", ";outline:none;cursor:pointer;&:hover{--table-row-right-icon-color:", ";background:", ";}", " &:active{background:", ";box-shadow:none;}"], token.gray200, token.radiusLarge, token.colorTextMuted, token.gray25, props.$isFocusVisible && css(["--table-row-right-icon-color:", ";background:", ";box-shadow:inset 0 0 0 2px ", ",inset 0 0 0 4px ", ";&:hover{box-shadow:inset 0 0 0 2px ", ",inset 0 0 0 4px ", ";}"], token.colorTextMuted, token.gray25, token.gray100, token.gray10, token.gray50, token.gray10), token.gray50), (props) => props.$isPressed && css(["--table-row-right-icon-color:", ";&,&:hover{background:", ";}"], token.colorTextMuted, token.gray50), (props) => props.$isDisabled && css(["--table-row-right-icon-color:", ";--table-thumbnail-opacity:50%;--table-row-color-override:", ";pointer-events:none;"], token.gray200, token.gray200));
const Icon = styled.div.withConfig({
  displayName: "Icon",
  componentId: "sc-noi3s7-1"
})(["color:var(--table-row-right-icon-color);"]);
export {
  Row,
  StyledRow
};
//# sourceMappingURL=Row2.js.map
